import { MediaType } from 'APP/model/message/messageModel.types';
import { messageModel } from 'APP/model/model';
import Entities from 'STORE';

export async function updateSharedDataCount(groupId: string): Promise<void> {
  try {
    const group = Entities.GroupsStore.getGroupById(groupId);
    if (!group) {
      return;
    }

    const mediaTypes = [
      MediaType.Image,
      MediaType.Video,
      MediaType.File,
      MediaType.Link,
      MediaType.Audio,
      MediaType.Voice,
      MediaType.Article,
    ];

    const sharedData = group.sharedData;
    const countsData = await messageModel.getMessagesByMediaTypesCount({ groupId, mediaTypes });

    sharedData.media.updateCount(countsData[MediaType.Image] + countsData[MediaType.Video]);
    sharedData.files.updateCount(countsData[MediaType.File]);
    sharedData.links.updateCount(countsData[MediaType.Link]);
    sharedData.audio.updateCount(countsData[MediaType.Audio]);
    sharedData.voices.updateCount(countsData[MediaType.Voice]);
    sharedData.articles.updateCount(countsData[MediaType.Article]);
  } catch {
    // do nothing
  }
}
